export const locale = {
    lang: 'de',
    data: {
      'LOGIN': {
        'AUTENTICACION': {
          'TITULO': 'Zweistufige Authentifizierung',
          'SUBTITULO': 'Um mehr Sicherheit beim Betreten der Plattform zu gewährleisten, ist es notwendig, dass Sie die zweistufige Authentifizierung wie unten angegeben durchführen',
          'BOTONES': {
            'SIGUIENTE': 'Nächster',
            'ANTERIOR': 'Bisherige'
          },
          'PASOS': {
            '1': {
              'TITULO': 'Schritt 1',
              'INSTRUCCION': 'Scannen Sie den QR-Code mit der mobilen App von Google Authenticator und klicken Sie auf die Schaltfläche Weiter',
              'REGISTRADO': 'Es wurde festgestellt, dass Ihre E-Mail bereits in der Google Authenticator-Anwendung registriert ist. Es ist nicht erforderlich, den QR-Code erneut zu scannen, fahren Sie mit dem nächsten Schritt fort'
            },
            '2': {
              'TITULO': 'Schritt 2',
              'INSTRUCCION': 'Geben Sie den von Google Authenticator bereitgestellten Schlüssel ein und klicken Sie auf Weiter ',
              'INPUT': 'Schlüssel erhalten',
              'INFOPREVIA': {
                'INFO_1': 'Es wurde festgestellt, dass Sie bereits von diesem Computer aus auf die Plattform zugegriffen haben. Kein erneutes Scannen des QR-Codes erforderlich',
                'INFO_2': 'Geben Sie einfach das von Google Authenticator für Ihr Konto bereitgestellte Passwort ein und klicken Sie auf Weiter',
                'INFO_3': 'Wenn Sie den QR-Code erneut scannen möchten, klicken Sie auf die Schaltfläche Zurück',
                'INFO_4': 'Achtung: Auf diese Weise müssen Sie Ihr Konto erneut mit Google Authenticator verknüpfen',
              }
            },
            '3': {
              'TITULO': 'Ergebnis',
              'INSTRUCCION': 'Geben Sie den Schlüssel ein, den Sie im vorherigen Schritt aus dem QR-Code erhalten haben, und klicken Sie auf die Schaltfläche Weiter',
              'VALIDANDO': 'Bestätigen Sie den eingegebenen Schlüssel, warten Sie einen Moment',
              'MAL': 'Der Schlüssel ist falsch oder abgelaufen, bitte geben Sie den Schlüssel erneut ein und versuchen Sie es erneut',
              'BIEN': 'Sie haben die Authentifizierung erfolgreich abgeschlossen, dann betreten Sie die Plattform'
            },
          }
        },
        'PASSWORD':{
          'AVISO':'Bitte geben Sie Ihre E-Mail-Adresse ein, wir senden Ihnen einen Link, um Ihr Passwort zu ändern',
          'BTN':'E-Mail senden',
          'PLACERHOLDER':'Email-Adresse',
          'ERROR':'Wir haben Ihre E-Mail nicht gefunden. Bitte versuchen Sie eine andere E-Mail',
          'TRUE':'Die E-Mail wurde versendet, bitte prüfen Sie stattdessen Ihren Posteingang oder Spam-Ordner'
        },
        'RESET':{
          'LABEL01':'Bitte... geben Sie Ihr neues Passwort für den Benutzer ein:   ',
          'LABEL02':'Passwort',
          'LABEL03':'Passwort erneut eingeben',
          'BTN':'Passwort ändern',
          'ERROR':'Fehler, das Token wurde nicht gefunden',
          'NOPASSWORDMATCH':'Das Passwort stimmt nicht überein',
          'CARACTERES':'Muss aus mindestens 3 Zeichen bestehen',
          'SUCCESSCHANGE':'Ihr Passwort wurde korrekt geändert'
        },
        'LANDING': {
          'MENSAJE': 'Willkommen',
          'NAVEG': ''
          //'NAVEG': 'The use of <a class="linkChrome" href="https://www.google.com/intl/es-419/chrome/" target="blank">Google Chrome</a> browser is recommended'
        },
        'MODALES': {
          'AVISO1': {
            'TITULO': 'Wichtige Ankündigung.',
            'TEXTO': `Sehr geehrter Nutzer:<br><br>
            Sie werden darüber informiert, dass zur Optimierung des Services ein Update der Cultural GO Plattform durchgeführt wird.<br><br>
            Das Update findet am <strong>Freitag, 23. Juli, ab 23:59 Uhr statt. bis Samstag, 24. Juli, 23:59 Uhr</strong>. Während dieser Zeit bleibt die Plattform inaktiv. Die aktuellen Umfragen bleiben jedoch aktiv.<br><br>
            `
          }
        },
        'FORM': {
          'FORGOTPASSWORD':'Passwort-Wiederherstellung',
          'LOGIN':'Anmelden',
          'TITULO':'LOGIN IN IHR KONTO',
          'INPUT':{
            'EMAIL':'E-Mail',
            'PASSWORT': 'Passwort',
            'LANGSEL': 'Wählen Sie eine Sprache'
          },
          'VAL': {
            'NOTEMAIL': 'E-Mail ist erforderlich ',
            'INVEMAIL': 'Bitte geben Sie eine gültige E-Mail-Adresse ein ',
            'CARACT_EMA': ' Feld lässt die folgenden Zeichen nicht zu /&¿+#$%([=])*?"<>:\'',
            // 'PASS': 'Passwort ist erforderlich ',
            'PASS': 'Ungültiges Passwort',
          },
          'SIGNIN': 'GO!',
          'CAMBIALOGO': 'Klicken Sie hier, um Ihr Firmenlogo zu ändern',
          'CARGAOK': 'Ihr Firmenlogo wurde korrekt geladen',
          'CARGANULL': 'Es gab einen Fehler beim Laden Ihres Firmenlogos',
          'CARGAERROR': 'Das Format der ausgewählten Datei ist nicht korrekt. Es werden nur Formate akzeptiert: jpg, png, gif'
        }
      },
      'LOGIN-ENCUESTADOR':{
        'FORM': {
          'TITULO': 'INGRESE A SU CUENTA',
          'INPUT':{
            'PASSWORT': 'Passwort:',
            'LANGSEL': 'Wählen Sie eine Sprache:',
            'LOGIN': 'Anmelden',
          },

      },
      'INTRO-LOGIN':{
        'TITEL': 'ANWEISUNGEN',
        'TEXT1': 'Great Place to Work® Institute. heißt Sie willkommen, Ihre Arbeitsklima-Umfrage 100% vertraulich zu beantworten',
        'TEXT2': 'Vertraulichkeit',
        'TEXT3': 'Im Institut:',
        'TEXT4': 'Wir verwalten, verarbeiten und analysieren die Antworten statistisch nach Organisation und Bereich',
        'TEXT5': 'Wir generieren globale Ergebnisse, die die Verbesserungsmaßnahmen im Klima der Organisation anzeigen.',
        'TEXT6': 'Sie werden die einzelnen Antworten nicht kennen',
        'TEXT7': 'Individuelle Antworten sind streng vertraulich,',
        'TEXT8': 'Beschwerden und Anregungen',
         'TEXT9':' Es ist strengstens untersagt:',
         'TEXT10': 'um Sie in irgendeiner Weise zu beeinflussen, zu bestrafen oder daran zu hindern, die Umfrage frei zu beantworten.',
         'TEXT11': 'Für Beschwerden oder Anregungen stehen wir Ihnen unter folgender Mail zur Verfügung:',
         'TEXT12': 'mx_transparencia@greatplacetowork.com',
         'TEXT13': 'Anweisungen:',
         'TEXT14':'1. Geben Sie Ihre ',
         'TEXT15': 'Mitarbeiternummer + Geburtsjahr',
         'TEXT16':'2. lassen Sie keine Leerzeichen.',
         'TEXT17':'3. Klicken Sie auf Start',
         'TEXT18': 'Helfen Sie uns, die Umfrage des Great Place to Work® Institute zu beantworten.',
      }

    },
    'LOADING':{
      'TEXT_WELCOM':'Willkommen bei CulturalGo',
     'TEXT_CHANGE':'Informationen werden geladen...',
    }
    }
};
